import { lazy, Suspense } from "react"
import { useLoadedOnMouseMove } from "~/sdk/useUI"
import type { Props } from "~/components/popup/newsletter/popup"

const NewsletterPopup = lazy(() => import('~/components/popup/newsletter/popup'))

export default function Newsletter(props: Props) {
    const loaded = useLoadedOnMouseMove()

    return <Suspense fallback={null}>{loaded && <NewsletterPopup {...props} />}</Suspense>
}
